import { useEffect, useState } from "react";
import {
    useNavigate,
    useParams
} from "react-router-dom";

import Swal from "sweetalert2";

import API_BASE_URL from "../config/api";


function EditSocialLinks() {

    const { id } = useParams();

    const navigate = useNavigate();


    /*
    |--------------------------------------------------------------------------
    | Form State
    |--------------------------------------------------------------------------
    */

    const [whatsapp, setWhatsapp] = useState("");

    const [instagram, setInstagram] = useState("");

    const [facebook, setFacebook] = useState("");

    const [youtube, setYoutube] = useState("");

    const [telegram, setTelegram] = useState("");

    const [mobile, setMobile] = useState("");

    const [status, setStatus] = useState("Enable");


    /*
    |--------------------------------------------------------------------------
    | Loading
    |--------------------------------------------------------------------------
    */

    const [loading, setLoading] = useState(true);

    const [saving, setSaving] = useState(false);


    /*
    |--------------------------------------------------------------------------
    | WhatsApp Number Change
    |--------------------------------------------------------------------------
    */

    const handleWhatsappChange = (e) => {

        // केवल numbers allow करें
        const value = e.target.value.replace(/\D/g, "");

        // Maximum 15 digits
        setWhatsapp(value.slice(0, 15));
    };


    /*
    |--------------------------------------------------------------------------
    | Mobile Number Change
    |--------------------------------------------------------------------------
    */

    const handleMobileChange = (e) => {

        // केवल numbers allow करें
        const value = e.target.value.replace(/\D/g, "");

        // Maximum 15 digits
        setMobile(value.slice(0, 15));
    };


    /*
    |--------------------------------------------------------------------------
    | Fetch Social Links
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        const fetchSocialLinks = async () => {

            try {

                const response = await fetch(
                    `${API_BASE_URL}/admin/social-links/${id}`,
                    {
                        method: "GET",

                        headers: {
                            "Accept": "application/json"
                        },

                        credentials: "include"
                    }
                );


                const data = await response.json();


                console.log(
                    "Edit Social Links Response:",
                    data
                );


                if (response.ok && data.success) {

                    /*
                    |----------------------------------------------------------
                    | Support both response formats
                    |----------------------------------------------------------
                    */

                    const item =
                        data.social_links ||
                        data.social_link ||
                        {};


                    setWhatsapp(
                        item.whatsapp
                            ? String(item.whatsapp).replace(/\D/g, "")
                            : ""
                    );


                    setInstagram(
                        item.instagram || ""
                    );


                    setFacebook(
                        item.facebook || ""
                    );


                    setYoutube(
                        item.youtube || ""
                    );


                    setTelegram(
                        item.telegram || ""
                    );


                    setMobile(
                        item.mobile
                            ? String(item.mobile).replace(/\D/g, "")
                            : ""
                    );


                    setStatus(
                        item.status || "Enable"
                    );

                } else {

                    Swal.fire({

                        icon: "error",

                        title: "Unable to Load",

                        text:
                            data.message ||
                            "Social links not found."
                    });


                    navigate("/social-links");
                }

            } catch (error) {

                console.error(
                    "Fetch Social Links Error:",
                    error
                );


                Swal.fire({

                    icon: "error",

                    title: "Server Error",

                    text:
                        "Unable to connect with server."
                });


                navigate("/social-links");

            } finally {

                setLoading(false);
            }
        };


        fetchSocialLinks();

    }, [id, navigate]);


    /*
    |--------------------------------------------------------------------------
    | Update
    |--------------------------------------------------------------------------
    */

    const handleSubmit = async (e) => {

        e.preventDefault();


        try {

            setSaving(true);


            const response = await fetch(
                `${API_BASE_URL}/admin/social-links/${id}`,
                {
                    method: "PUT",

                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                    },

                    credentials: "include",

                    body: JSON.stringify({

                        // WhatsApp में केवल number जाएगा
                        whatsapp: whatsapp.trim(),

                        instagram: instagram.trim(),

                        facebook: facebook.trim(),

                        youtube: youtube.trim(),

                        telegram: telegram.trim(),

                        mobile: mobile.trim(),

                        status: status

                    })
                }
            );


            const data = await response.json();


            if (response.ok && data.success) {

                await Swal.fire({

                    icon: "success",

                    title: "Updated!",

                    text:
                        data.message ||
                        "Social links updated successfully.",

                    timer: 1500,

                    showConfirmButton: false
                });


                navigate("/social-links");

            } else {

                let errorMessage =
                    data.message ||
                    "Something went wrong.";


                if (data.errors) {

                    const errors = Object.values(
                        data.errors
                    ).flat();


                    if (errors.length > 0) {

                        errorMessage =
                            errors.join("\n");
                    }
                }


                Swal.fire({

                    icon: "error",

                    title: "Unable to Update",

                    text: errorMessage
                });
            }

        } catch (error) {

            console.error(
                "Update Social Links Error:",
                error
            );


            Swal.fire({

                icon: "error",

                title: "Server Error",

                text:
                    "Unable to connect with server."
            });

        } finally {

            setSaving(false);
        }
    };


    /*
    |--------------------------------------------------------------------------
    | Loading
    |--------------------------------------------------------------------------
    */

    if (loading) {

        return (

            <div className="container-fluid">

                <div className="text-center py-5">

                    <div
                        className="spinner-border text-primary"
                        role="status"
                    />

                    <p className="mt-2">
                        Loading social links...
                    </p>

                </div>

            </div>
        );
    }


    /*
    |--------------------------------------------------------------------------
    | UI
    |--------------------------------------------------------------------------
    */

    return (

        <div
            className="container-fluid py-4"
            style={{
                maxHeight: "500px",
                overflowX: "auto",
                overflowY: "auto"
            }}
        >


            {/* Header */}

            <div className="d-flex justify-content-between align-items-center mb-4">

                <h3 className="mb-0">
                    Edit Social Links
                </h3>


                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() =>
                        navigate("/social-links")
                    }
                >
                    Back
                </button>

            </div>


            {/* Card */}

            <div className="card shadow-sm">

                <div className="card-body">

                    <form onSubmit={handleSubmit}>


                        {/* WhatsApp */}

                        <div className="mb-3">

                            <label className="form-label fw-semibold">
                                WhatsApp Number
                            </label>


                            <input
                                type="tel"
                                className="form-control"
                                placeholder="919999999999"
                                value={whatsapp}
                                onChange={handleWhatsappChange}
                                maxLength="15"
                                inputMode="numeric"
                            />


                            <small className="text-muted">
                               only enter whatsapp number like 919999999999
                            </small>

                        </div>


                        {/* Instagram */}

                        <div className="mb-3">

                            <label className="form-label fw-semibold">
                                Instagram
                            </label>


                            <input
                                type="url"
                                className="form-control"
                                placeholder="https://instagram.com/homoeoadda"
                                value={instagram}
                                onChange={(e) =>
                                    setInstagram(e.target.value)
                                }
                            />

                        </div>


                        {/* Facebook */}

                        <div className="mb-3">

                            <label className="form-label fw-semibold">
                                Facebook
                            </label>


                            <input
                                type="url"
                                className="form-control"
                                placeholder="https://facebook.com/homoeoadda"
                                value={facebook}
                                onChange={(e) =>
                                    setFacebook(e.target.value)
                                }
                            />

                        </div>


                        {/* YouTube */}

                        <div className="mb-3">

                            <label className="form-label fw-semibold">
                                YouTube
                            </label>


                            <input
                                type="url"
                                className="form-control"
                                placeholder="https://youtube.com/@homoeoadda"
                                value={youtube}
                                onChange={(e) =>
                                    setYoutube(e.target.value)
                                }
                            />

                        </div>


                        {/* Telegram */}

                        <div className="mb-3">

                            <label className="form-label fw-semibold">
                                Telegram
                            </label>


                            <input
                                type="url"
                                className="form-control"
                                placeholder="https://t.me/homoeoadda"
                                value={telegram}
                                onChange={(e) =>
                                    setTelegram(e.target.value)
                                }
                            />

                        </div>


                        {/* Mobile */}

                        <div className="mb-3">

                            <label className="form-label fw-semibold">
                                Mobile Number
                            </label>


                            <input
                                type="tel"
                                className="form-control"
                                placeholder="9999999999"
                                maxLength="15"
                                inputMode="numeric"
                                value={mobile}
                                onChange={handleMobileChange}
                            />

                        </div>


                        {/* Status */}

                        <div className="mb-4">

                            <label className="form-label fw-semibold">
                                Status
                            </label>


                            <select
                                className="form-select"
                                value={status}
                                onChange={(e) =>
                                    setStatus(e.target.value)
                                }
                            >

                                <option value="Enable">
                                    Enable
                                </option>

                                <option value="Disable">
                                    Disable
                                </option>

                            </select>

                        </div>


                        {/* Buttons */}

                        <div className="d-flex gap-2">

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={saving}
                            >

                                {saving ? (

                                    <>
                                        <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                        />

                                        Updating...
                                    </>

                                ) : (

                                    "Update Social Links"

                                )}

                            </button>


                            <button
                                type="button"
                                className="btn btn-secondary"
                                disabled={saving}
                                onClick={() =>
                                    navigate("/social-links")
                                }
                            >
                                Cancel
                            </button>

                        </div>

                    </form>

                </div>

            </div>

        </div>
    );
}


export default EditSocialLinks;